<template>
  <div class="devices-compact-list">
    <div v-for="device in devices" :key="device.mac" class="device-row-compact">
      <div class="device-icon-box">
        <font-awesome-icon :icon="getDeviceIcon(device)" class="device-icon-mini" />
      </div>
      <div class="device-name-compact">
        {{ device.name || device.dhcpName || 'unknown' }}
      </div>
      <div class="device-status-badge" :class="device.active ? 'active' : 'inactive'">
        {{ device.active ? 'Active' : 'Inactive' }}
      </div>
    </div>
    <div v-if="devices.length === 0" class="no-devices">
      <p>No devices connected</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "DevicesCompact",
  props: {
    devices: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  methods: {
    getDeviceIcon(device) {
      const name = (device.name || device.dhcpName || '').toLowerCase();
      if (name.includes('phone') || name.includes('iphone') || name.includes('android')) {
        return ['fas', 'mobile-alt'];
      } else if (name.includes('laptop') || name.includes('macbook')) {
        return ['fas', 'laptop'];
      } else if (name.includes('tv') || name.includes('roku') || name.includes('chromecast')) {
        return ['fas', 'tv'];
      } else if (name.includes('tablet') || name.includes('ipad')) {
        return ['fas', 'tablet-alt'];
      } else {
        return ['fas', 'mobile-alt'];
      }
    }
  }
};
</script>

<style scoped>
.devices-compact-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.device-row-compact {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: var(--color-divider);
  border-radius: 10px;
  transition: all 0.2s ease;
}

.device-row-compact:hover {
  background: var(--color-background-input-no-opacity);
  opacity: 0.8;
}

.device-icon-box {
  width: 36px;
  height: 36px;
  background: var(--color-card);
  border: 1px solid var(--color-card-border);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.device-icon-mini {
  font-size: 16px;
  color: var(--text-muted);
}

.device-name-compact {
  flex: 1;
  font-size: 0.875rem;
  color: var(--text-primary);
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.device-status-badge {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: capitalize;
  flex-shrink: 0;
}

.device-status-badge.active {
  background: rgba(107, 171, 144, 0.2);
  color: #6BAB90;
}

.device-status-badge.inactive {
  background: rgba(210, 56, 56, 0.15);
  color: var(--error-red);
}

.no-devices {
  padding: 24px;
  text-align: center;
  color: var(--text-muted);
  font-size: 0.875rem;
}

/* Mobile Responsive */
@media (max-width: 480px) {
  .device-row-compact {
    gap: 10px;
    padding: 10px;
  }

  .device-icon-box {
    width: 32px;
    height: 32px;
  }

  .device-icon-mini {
    font-size: 14px;
  }

  .device-name-compact {
    font-size: 0.8rem;
  }

  .device-status-badge {
    padding: 3px 10px;
    font-size: 0.7rem;
  }
}

@media (max-width: 375px) {
  .device-row-compact {
    gap: 8px;
    padding: 8px;
  }

  .device-icon-box {
    width: 28px;
    height: 28px;
  }

  .device-icon-mini {
    font-size: 12px;
  }

  .device-name-compact {
    font-size: 0.75rem;
  }

  .device-status-badge {
    padding: 2px 8px;
    font-size: 0.65rem;
  }

  .no-devices {
    padding: 16px;
    font-size: 0.8rem;
  }
}
</style>